// src/data/mediaArticles.js

// Add or edit articles here.
// image can be a local path in /public or a full URL.
const MEDIA_ARTICLES = [
  
  {
    id: "2025-kepithor-theblockopedia",
    title: "Blockopedia Article",
    outlet: "theblockopedia.com",
    date: "Dec 12, 2025",
    image: "https://theblockopedia.com/wp-content/uploads/2025/12/Untitled-design-2025-12-12T125405.095.png",
    url: "https://theblockopedia.com/kepithor-studios-redefining-web3-gaming-through-fun-diverse-games-and-sustainable-economies/",
    description: "Kepithor Studios: Redefining Web3 Gaming Through Fun, Diverse Games and Sustainable Economies",
  },
  {
    id: "2025-kepithor-bitcourier",
    title: "Bitcourier Review",
    outlet: "Bitcourier.co.uk",
    date: "July 17, 2025",
    image: "https://bitcourier.co.uk/storage/kepithorr.png",
    url: "https://bitcourier.co.uk/blog/kepithor-review",
    description: "A fresh take on web3 gaming with real rewards",
  },
  {
    id: "2024-rampage-egamers",
    title: "Royal Rampage Release ",
    outlet: "Egamers.io",
    date: "Dec 9, 2024",
    image: "https://egamers.io/wp-content/uploads/2024/12/Untitled-design-6-1600x900.jpg",
    url: "https://egamers.io/kepithor-studios-launches-royal-rampage-with-up-to-2m-kkt-in-alpha-airdrop-rewards/",
    description: "Kepithor Studios Launches Royal Rampage with Up to 2M KKT in Alpha Airdrop Rewards",
  },
  // Add more...
];

export default MEDIA_ARTICLES;
